import { Grupo } from '../../core/domain/grupo/grupo';
import { GrupoDto } from '../dto/grupo.dto';
import { FuncionalidadeMapper } from './funcionalidade.mapper';

export class GrupoMapper {
  static toDomain(grupoDto: GrupoDto): Grupo {
    return {
      id: grupoDto.id,
      descricao: grupoDto.descricao,
      funcionalidades: grupoDto.funcionalidades.map(
        FuncionalidadeMapper.toDomain
      )
    };
  }

  static toDTO(grupo: Grupo): GrupoDto {
    return {
      id: grupo.id,
      descricao: grupo.descricao,
      funcionalidades: grupo.funcionalidades.map(FuncionalidadeMapper.toDTO)
    };
  }
}
